module.exports = __webpack_public_path__ + "static/media/develop-02.ca63c44b.png";